import { ExternalLink, MessageSquare } from "lucide-react";
import { buttonChrome } from "@/components/ui/button";
import { IconTile } from "@/components/ui/IconTile";
import { CAPTION_LINE } from "@/components/ui/marks";
import { Panel } from "@/components/ui/Panel";
import { useDraftSurvey } from "@/hooks/use-generate";

function Offer({ link }: { link: string }) {
  return (
    <div className="flex items-start gap-3">
      <IconTile>
        <MessageSquare />
      </IconTile>
      <div className="flex-1">
        <p className="text-sm font-bold">
          Tell us about your experience of using Praxis
        </p>
        <p className="mt-1 text-sm text-muted-foreground">
          An optional short survey. Tell the team behind Praxis about your
          experience of drafting this draft, and share any suggestions for how
          the platform could be improved.
        </p>
      </div>
      <div className="flex flex-none flex-col items-center gap-1">
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className={buttonChrome({ variant: "secondary" })}
        >
          Start Survey
          <ExternalLink />
        </a>
        <span className={CAPTION_LINE}>Approx. 3 mins</span>
      </div>
    </div>
  );
}

function Thanks() {
  return (
    <div>
      <p className="text-sm font-bold">Thank you for your feedback</p>
      <p className="mt-1 text-sm text-muted-foreground">
        Your answers go to the team behind Praxis and help shape what comes
        next.
      </p>
    </div>
  );
}

/**
 * The finished draft's survey, offered on the ready page until it is answered
 * and then thanked for. It draws nothing, its rule included, where there is no
 * survey to offer or the server could not say, since the survey must never
 * stand in the way of the draft.
 */
export function SurveyCard({ taskId }: { taskId: string }) {
  const { data: survey } = useDraftSurvey(taskId);
  if (survey === undefined) return null;
  if (survey.link === null && !survey.answered) return null;

  return (
    <>
      <hr className="my-10 border-border" />
      <Panel shape="card" pad="snug" className="mt-3 text-left">
        {survey.link !== null ? <Offer link={survey.link} /> : <Thanks />}
      </Panel>
    </>
  );
}
